import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";

export function UsersPageTitle(props: {
  userCount: number,
}) {
  const { userCount } = props;
  const { t } = useTranslation();
  return (
    <Box display={"flex"} alignItems={"center"} marginRight={1}>
      <Typography variant={"h5"} sx={{
        alignSelf: 'center',
        marginRight: 1,
        fontSize: '1.2rem'
      }}>{t('User.titleLong')}</Typography>
      ({userCount})
    </Box>
  )
}
